import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { apiAxios } from "../../../utils/apiAxios";
import { getAuthToken } from "../../../utils/auth";
import SlotSchedule from "./SlotSchedule";
import { getSlotEndTime, normalizeYMD } from "../../../utils/slotBooking";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

interface Props {
  show: boolean;
  order: any;
  onClose: () => void;
  onRescheduled: () => void;
}

const RescheduleSlotModal: React.FC<Props> = ({ show, order, onClose, onRescheduled }) => {
  const [date, setDate] = useState(normalizeYMD(order?.slotDate));
  const [time, setTime] = useState("");
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    try {
      setSaving(true);
      await apiAxios.post(
        `${API_BASE}/Dentist/RescheduleSlotOrder`,
        {
          caseID: order?.caseID,
          slotDate: date,
          slotTime: time,
          slotEndTime: getSlotEndTime(time),
        },
        {
          headers: {
            AuthorizationData: getAuthToken(),
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Order rescheduled");
      onRescheduled();
    } catch (err) {
      console.error(err);
      toast.error("Failed to reschedule. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Order {order?.orderID}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SlotSchedule
          slotDate={date}
          slotTime={time}
          onDateChange={setDate}
          onTimeChange={setTime}
          onContinue={confirm}
          continueLabel={saving ? "Saving..." : "Confirm Reschedule"}
        />
      </Modal.Body>
    </Modal>
  );
};

export default RescheduleSlotModal;
